import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "./LanguageContext";
import { OrnamentDivider } from "./Motifs";

// One-time curtain intro that opens to reveal the hero
export default function Curtain() {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setOpen(true), 1500);
    const t2 = setTimeout(() => setDone(true), 3100);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="curtain-intro"
          className="fixed inset-0 z-[100] flex"
          initial={false}
          exit={{ opacity: 0, transition: { duration: 0.4 } }}
        >
          {/* left panel */}
          <motion.div
            className="relative h-full w-1/2 bg-ink"
            animate={{ x: open ? "-100%" : "0%" }}
            transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1] }}
          />
          {/* right panel */}
          <motion.div
            className="relative h-full w-1/2 bg-ink"
            animate={{ x: open ? "100%" : "0%" }}
            transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1] }}
          />

          {/* centered monogram */}
          <motion.div
            className="pointer-events-none absolute inset-0 z-10 flex flex-col items-center justify-center"
            animate={{ opacity: open ? 0 : 1, scale: open ? 1.1 : 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <span className="font-display text-6xl md:text-8xl text-cream tracking-wide">
              N <span className="text-gold">&amp;</span> E
            </span>
            <OrnamentDivider className="mt-4 w-40 opacity-80" color="#C5A059" />
            <span className="mt-4 font-sans text-[10px] uppercase tracking-[0.4em] text-cream/60">
              {t.hero.dateLine}
            </span>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
